import { render } from "./UserRecovery.vue?vue&type=template&id=2732059e&scoped=true"
import script from "./UserRecovery.vue?vue&type=script&lang=js"
export * from "./UserRecovery.vue?vue&type=script&lang=js"

import "./UserRecovery.vue?vue&type=style&index=0&id=2732059e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2732059e"]])

export default __exports__